import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpRegionSummaryPage } from '@/features/marketPromotion/pages/MpRegionSummaryPage';
import { mpRegionSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/region-summary/')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.REGION_SUMMARY_VIEW),
  validateSearch: mpRegionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Region-Wise Market Promotion">
      <Suspense fallback={<PageLoader />}>
        <MpRegionSummaryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
